export default __webpack_public_path__ + "ce66b288f664149219c090c58e26f780.png";